import { render, staticRenderFns } from "./select-id-from-origin.vue?vue&type=template&id=57c60c37&"
import script from "./select-id-from-origin.vue?vue&type=script&lang=js&"
export * from "./select-id-from-origin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports